import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const get_raffle_info = createAsyncThunk(
  'OffsiteShare/get_raffle_info',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/get_raffle_info',
      {pool_type: 'screenshot_share'},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp?.data?.data?.rewards || []
  }
)

export const user_raffle = createAsyncThunk(
  'OffsiteShare/user_raffle',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/user_raffle',
      {pool_type: 'screenshot_share', ...p},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp?.data?.data || {}
  }
)

const initialState: {
  prizeList: Array<any>
} = {
  prizeList: [],
}

export function useOffsiteShare() {
  return useSelector((store) => store.OffsiteShare)
}

export const OffsiteShareSlice = createSlice({
  name: 'OffsiteShare',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_raffle_info.fulfilled, (state, action) => {
      Object.assign(state.prizeList, action.payload)
    })
  },
})

export default OffsiteShareSlice.reducer
export const OffsiteShareActions = OffsiteShareSlice.actions
